import React from 'react';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="home-page">
      <div className="home-content">
        <div className="hero-section">
          <div className="character-container">
            <img 
              src="/images/jj_illus_character_large.png" 
              alt="Jeeves Junior Character" 
              className="character-image"
            />
          </div>
          <div className="welcome-text">
            <h1 className="welcome-title">
              Welcome to Jeeves Junior, an AI chatbot
            </h1>
            <p className="welcome-description">
              Jeeves Junior is the brainchild of Ask Jeeves co-founder and CTO David Warthen, who asked himself the question: "If I were to build Jeeves with today's technology, what would I build?" Using the same conceptual framework and values used to build Jeeves (and also given the limited resources) the result is Jeeves Junior.
            </p>
          </div>
        </div>
        
        <div className="service-section">
          <div className="service-content">
            <div className="service-text">
              <h2 className="service-title">Ready to serve</h2>
              <p className="service-description">
                Following in the footsteps of his conceptual father, Jeeves Junior continues the tradition of being your "internet concierge", always ready to serve. Jeeves Junior uses today's AI technology, while offering a more human approach to answering questions and finding information.
              </p>
            </div>
            <div className="service-icon-container">
              <img 
                src="/images/jj_illus_serve.png" 
                alt="Service Icon" 
                className="service-icon"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage; 